import React, { useState } from "react";
import ToastMsg from "../../component/comman/ToastMsg";
import { useNavigate } from "react-router-dom";
import { changePin } from "../../services/ApiServices";

const ChangePin = () => {
  const navigate = useNavigate();
  const [user_pin, setUpdatePin] = useState("");

  const handlePinUpdates = () => {
    const pinData = {
      user_pin,
    };

    changePin(pinData)
      .then((res) => {
        if (res.status === 200) {
          ToastMsg("Pin updated successfully!", "success");
        } else {
          console.error("Failed to update pin:", res?.data);
          ToastMsg("Failed to update pin", "error");
        }
      })
      .catch((err) => {
        if (err.response?.status === 401) {
          navigate("/");
        }
        let error = err?.response?.data?.error || "something went wrong";
        ToastMsg(error, "error");
      });
  };

  return (
    <>
      <div className="profile-upper-wrapper">
        <div className="profile-picture">
          <p style={{fontSize:"25px"}}>
            {(localStorage.getItem("first_name") || "").charAt(0).toUpperCase()}
            {(localStorage.getItem("last_name") || "").charAt(0).toUpperCase()}
          </p>
        </div>
      </div>
      <div className="profile-lower-wrapper text-center w-100 w-lg-50">
        <div className="toggle-sc d-flex align-items-center justify-content-center">
        <h3 style={{ textTransform: "capitalize", marginTop:"-20px"}}>{localStorage.getItem("first_name") + " " + localStorage.getItem("last_name")}</h3>
        </div>
        <div className="card">
          <div className="card-body">
            <form>
              <div className="form-group">
                <label htmlFor="ols">Update Pin</label>
                <input
                  type="text"
                  id="ols"
                  className="form-control"
                  value={user_pin}
                  onChange={(e) => setUpdatePin(e.target.value)}
                />
              </div>
            </form>
          </div>
        </div>
        <div className="button-wrapper">
          <button className="btn">Cancel</button>
          <button className="btn" onClick={handlePinUpdates}>
            Change Pin
          </button>
        </div>
      </div>
    </>
  );
};

export default ChangePin;
